import React, { useState } from 'react';
import { Tabs } from '../../../components';
import { useQueryParams } from '../../../hooks';
import { Webhooks } from './Webhooks';

// Admin "App Config" page — per-app configuration grouped into tabs, reusing the shared
// Tabs component + ?tab= deep-linking (same design as the global Settings page). Each tab is
// a self-contained component backed by the generic core.app_config store.
//
// TO ADD A NEW SETTINGS AREA: add another `<div label="…" tabid="…">` panel below with its
// own component. Storage (core.app_config), secret handling and masking are already generic.
export const AppConfig = () => {

  const { queryParams, setHistory } = useQueryParams()
  const [defaultSelectedTab] = useState({ tab: queryParams.tab })

  const onTabChange = (tab) => setHistory({ tab })

  return (
    <div className="AppConfig wide-margin">
      <Tabs className="slim left"
        onTabChange={onTabChange}
        defaultSelectedTab={defaultSelectedTab}
      >
        <div label="Webhooks" tabid="webhooks">
          <Webhooks />
        </div>
      </Tabs>
    </div>
  );
}
